import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import FormError from "../../../../shared/components/FormError";
import PTForm from "./PTForm";
import { loadPTAddDataRequest } from "../redux/Actions";

const PTAdd = ({ name, description, formName, categories, handleClose }) => {
  const dispatch = useDispatch();
  const [shouldCloseModal, setShouldCloseModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  let { loading, error } = useSelector((state) => state.employeeStatus);

  // After submition, the post request is done loading, and there's no errors
  useEffect(() => {
    if (shouldCloseModal && !loading) {
      if (!error) {
        handleClose(true);
      } else {
        setErrorMessage(error.msg);
      }
      setShouldCloseModal(false);
    }
  }, [loading, error, shouldCloseModal]);

  let empInfo = JSON.parse(localStorage.getItem("employee"));

  function submit(values) {
    delete values.id;
    values.created_by = empInfo.id
    values.updated_by = empInfo.id
    if (!description) {
      delete values.description
    }
    if (values.category_id <= 0) {
      delete values.category_id
    }
    dispatch(loadPTAddDataRequest(values, formName))
    setShouldCloseModal(true);
  }
  function cancel() {
    handleClose(false);
  }

  return (
    <>
      <FormError>
        {errorMessage}
      </FormError>
      <PTForm name={name} description={description} categories={categories} submit={submit} cancel={cancel} />
    </>
  );
};

export default PTAdd;
